<script setup lang="ts">
const t2 = useT2({
  notFound: {
    en: "Sorry, we couldn't find the product you're looking for.",
    lt: 'Atsiprašome, prekės, kurios ieškote, mūsų parduotuvėje nėra.',
  },
  msg2: {
    en: 'Please check out our',
    lt: 'Kviečiame peržiūrėti mūsų prekių',
  },
  catalog: { en: 'Products', lt: 'Prekės' },
})

const props = defineProps<{
  productSlug?: string | None
}>()

const { myLink } = useLinks()
const locale = useLocale()

console.error('[Product not found was rendered]', props.productSlug)
</script>

<template>
  <div>
    <div :class="$style.c1" class="_pl2">
      <h1 :class="$style.c2" class="_fw-xxxl _ls-xxxs _ws-m _fs34 _pb4">
        <span class="_pr2">{{ t2('notFound') }}</span>
        <span class="_pr1 _fw-xl" :class="$style.c3">{{ t2('msg2') }}</span>
        <LinkUi :to="myLink('search')" :txt="t2('catalog')" arrow :class="$style.link" class="_fw-xxl _relative _h64 m_fs21 _fs34 _pl4 _pr4" />
        .
      </h1>
    </div>

    <LazyIdleProductBanner hydrate-on-idle :locale />
  </div>
</template>

<style module>
.c1 {
  padding-top: 20vh;
  composes: global(m_pl1);
  composes: global(_pb140);
}
.c2 {
  max-width: 80%;
  width: 140ch;
  composes: global(_lh12);
}
.c3 {
  color: var(--black-3);
}
.c1 .link {
  line-height: 54px;
  /* margin-top: -19px; */
}
</style>
